import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PhoneIcon from '@mui/icons-material/Phone';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { IconButton } from '@mui/material';
import XIcon from '../../Images/XIcon'

import ForestIcon from '@mui/icons-material/Forest';
import NatureIcon from '@mui/icons-material/Nature';
import OpacityIcon from '@mui/icons-material/Opacity';
import { createTheme, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LeftSubDrawerMobile from './LeftSubDrawerMobile.component';
import LeftSubDrawerDesktop from './LeftSubDrawerDesktop.component';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import SvgIcon from '@mui/material/SvgIcon';
import { Link, Typography } from '@mui/material';
import FAQ_Waldzustand from '../../Ressources/FAQs_Waldzustand_062022.pdf';
import FAQ_Baumarten from "../../Ressources/FAQs_Baumarten_062022.pdf";
import {
    EmailShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from "react-share";
import {
    EmailIcon,
    LinkedinIcon,
    TwitterIcon,
    WhatsappIcon,
} from "react-share";

import useTranslation from '../../Language/useTranslation';
import { useLanguage } from '../../Language/LanguageContext';



function MixedForestIcon(props: any) {
    return (
        <SvgIcon {...props}>
            <path d="M22.3,18.25h-5.28v3.75h-2.98v-3.75h-1.9c2.38-1.35,3.96-3.9,3.96-6.79,0-2.08-.82-3.97-2.16-5.37l1.58-2.83,5.27,9.37h-1.5l3.01,5.62Zm-13.19,3.75v-3.78c3.38-.4,6-3.27,6-6.76,0-3.77-3.05-6.81-6.81-6.81S1.49,7.7,1.49,11.46c0,3.38,2.45,6.17,5.67,6.7v3.83h1.95Z"
            />
        </SvgIcon>
    );
}

export default function LeftSubDrawer(props: any) {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));
    let content = (<></>)
    let title = "";

    const t = useTranslation();
    const { language } = useLanguage();




    const handleChangeWaldzustandsLayer = (event: React.SyntheticEvent, newValue: number) => {
        props.setTabIndexWaldzustand(newValue);
        console.log("new value", newValue)

        switch (newValue) {
            case 0:
                props.setActiveLayer("waldbiomasseTrend")
                break;
            case 1:
                props.setActiveLayer("laubwaldTrend")
                break;
            case 2:
                props.setActiveLayer("nadelwaldTrend")
                break;
            case 3:
                props.setActiveLayer("laubwaldWasserTrend")
                break;
        }

    };


    switch (props.leftSubDrawerType) {


        case "FIRE":
            const links = {
                firmsFaq: "https://www.earthdata.nasa.gov/faq/firms-faq#ed-fire-on-ground",
                firmsDisclaimer: "https://www.earthdata.nasa.gov/learn/find-data/near-real-time/citation",
                dwd: "https://www.dwd.de/DE/leistungen/waldbrandgef/waldbrandgef.html"

            }

            // Function to replace placeholders with links
            const renderTextWithLinks = (text: any, replacements: any) => {
                return text.split(/(LINK_FAQ|LINK_DISCLAIMER|LINK_DWD)/).map((part: any, index: any) => {
                    if (part === "LINK_FAQ") {
                        const linkText = language === "en" ? "here" : "hier";
                        return <Link key={index} href={replacements.firmsFaq} target="_blank">{linkText}</Link>;
                    } else if (part === "LINK_DISCLAIMER") {
                        const linkText = language === "en" ? "disclaimer" : "Haftungsausschluss";
                        return <Link key={index} href={replacements.firmsDisclaimer} target="_blank">{linkText}</Link>;
                    } else if (part === "LINK_DWD") {
                        const linkText = language === "en" ? "current forest fire danger" : "aktuelle Waldbrandgefahr";
                        return <Link key={index} href={replacements.dwd} target="_blank">{linkText}</Link>;
                    } else {
                        return part;
                    }
                });
            };


            content = (
                <Box m={2}>
                    <Typography>{t.layersFeuer[0].description.text}</Typography>
                    <Typography gutterBottom>
                        {renderTextWithLinks(t.layersFeuer[0].description.disclaimer, links)}
                    </Typography>
                    <Typography>
                        {renderTextWithLinks(t.layersFeuer[0].description.weatherInfo, links)}
                    </Typography>
                </Box>
            );
            title = t.layerCategories.feuer.name;
            break;

        case "BAUMARTEN":
            content =
                (
                    <Box m={2}>
                        <h3>{t.layerCategories["baumartenHeading2"].name}</h3>
                        <Typography variant="body1" gutterBottom>
                            {t.layersBaumarten[0].description}
                        </Typography>
                    </Box>

                );
            title = t.layerCategories.baumarten.name;
            break;


        case "WALDZUSTAND":
            content =
                (
                    < Box >
                        {props.mobile ?
                            <Tabs variant="scrollable" allowScrollButtonsMobile value={props.tabIndexWaldzustand} onChange={handleChangeWaldzustandsLayer} aria-label="icon tabs example">
                                <Tab icon={<MixedForestIcon />} aria-label="phone" />
                                <Tab icon={<NatureIcon />} aria-label="phone" />
                                <Tab icon={<ForestIcon />} aria-label="favorite" />
                                <Tab icon={<OpacityIcon />} aria-label="person" />
                            </Tabs> :
                            <Tabs variant="fullWidth" value={props.tabIndexWaldzustand} onChange={handleChangeWaldzustandsLayer} aria-label="icon tabs example">
                                <Tab icon={<MixedForestIcon />} aria-label="phone" />
                                <Tab icon={<NatureIcon />} aria-label="phone" />
                                <Tab icon={<ForestIcon />} aria-label="favorite" />
                                <Tab icon={<OpacityIcon />} aria-label="person" />
                            </Tabs>



                        }

                        <Box m={2}>
                            <h4>{t.layersWaldzustand[props.tabIndexWaldzustand].name}</h4>
                            <Typography variant="body1" gutterBottom>
                                {t.layersWaldzustandDescriptions[t.layersWaldzustand[props.tabIndexWaldzustand].label]}
                            </Typography>
                        </Box>
                    </Box >
                );

            title = t.layerCategories.waldzustand.name; //todo: in extra Objekt in translations
            break;
        case "SCHADEN":
            content =
                (
                    <Box m={2}>
                        <h3>{t.layersSchaden[0].name} 2017-2023</h3>
                        <Typography variant="body1" gutterBottom>
                            {t.layersSchaden[0].description}
                        </Typography>
                    </Box>

                );
            title = t.layerCategories.schaden.name;
            break;
        case "BUNDESLAENDER":
            content =
                (
                    <SelectBundesland
                        bundesland={props.bundesland}
                        setBundesland={props.setBundesland}
                    />

                );
            title = t.layerCategories.bundesland.name;

            break;

        case "INFORMATIONEN":

            const replacements = {
                faqWaldzustand: FAQ_Waldzustand,
                faqBaumarten: FAQ_Baumarten,
                publication: "https://www.mdpi.com/2072-4292/14/14/3330/pdf",
                feedback: "mailto:support@remote-sensing-solutions.com?body=Request Waldmonitor"
            };

            const renderTextWithLinksInformation = (text: any, replacements: any) => {
                return text.split(/(LINK_FAQ_WALDZUSTAND|LINK_FAQ_BAUMARTEN|LINK_PUBLICATION|EMAIL_FEEDBACK)/).map((part: any, index: any) => {
                    switch (part) {
                        case "LINK_FAQ_WALDZUSTAND":
                            return <Link key={index} href={replacements.faqWaldzustand} target="_blank">{language === "en" ? "here" : "hier"}</Link>;
                        case "LINK_FAQ_BAUMARTEN":
                            return <Link key={index} href={replacements.faqBaumarten} target="_blank">{language === "en" ? "here" : "hier"}</Link>;
                        case "LINK_PUBLICATION":
                            return <Link key={index} href={replacements.publication} target="_blank">{language === "en" ? "here" : "hier"}</Link>;
                        case "EMAIL_FEEDBACK":
                            return <Link key={index} href={replacements.feedback}>{language === "en" ? "support@remote-sensing-solutions.com" : "support@remote-sensing-solutions.com"}</Link>;
                        default:
                            return part;
                    }
                });
            };

            content = (
                <Box m={2}>
                    <Typography variant="body1" gutterBottom>
                        {t.informationContent.intro}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        {renderTextWithLinksInformation(t.informationContent.faqWaldzustand, replacements)}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        {renderTextWithLinksInformation(t.informationContent.faqBaumarten, replacements)}
                    </Typography>
                    <Typography variant="body1" gutterBottom marginTop={6}>
                        {renderTextWithLinksInformation(t.informationContent.publication, replacements)}
                    </Typography>
                    <Typography variant="body1" gutterBottom marginTop={6}>
                        {renderTextWithLinksInformation(t.informationContent.feedback, replacements)}
                    </Typography>
                </Box>
            );
            title = t.layerCategories.informationen.name;
            break;

        case "TEILEN":

            const iconSize = 40
            content =
                (
                    <Box m={2}>
                        <Grid container justifyContent="space-evenly">
                            <Grid item>
                                <a href="https://x.com/" style={{ textDecoration: 'none' }}>
                                    <IconButton style={{ padding: 0, width: 38.75, height: 38.75 }}>
                                        <XIcon style={{ width: 38.75, height: 38.75 }} />
                                    </IconButton>
                                </a>

                            </Grid>
                            {/* <TwitterShareButton
                                    url={"https://map3d.remote-sensing-solutions.de/waldmonitor-deutschland/"}
                                    title="Release des Waldmonitors Deutschland"
                                    hashtags={["Waldmonitor", "Klimaschutz", "Klimawandel", "Naturgefahren", "Wald", "RemoteSensingSolutions", "NaturwaldAkademie"]}
                                // description={"aiueo"}
                                >

                                    <TwitterIcon size={iconSize} round />
                                </TwitterShareButton> */}
                            <Grid item>

                                <LinkedinShareButton
                                    url={"https://map3d.remote-sensing-solutions.de/waldmonitor-deutschland/"}
                                    title="Release des Waldmonitors Deutschland"
                                    summary='Der Waldmonitor Deutschland liefert erstmals eine satellitenbasierte Darstellung des Waldzustandes und der Verteilung der Hauptbaumarten.'
                                >
                                    <LinkedinIcon size={iconSize} round />
                                </LinkedinShareButton>
                            </Grid>
                            <Grid item>

                                <EmailShareButton
                                    url={"https://map3d.remote-sensing-solutions.de/waldmonitor-deutschland/"}
                                    subject="Release des Waldmonitors Deutschland"
                                    body='Der Waldmonitor Deutschland liefert erstmals eine satellitenbasierte Darstellung des Waldzustandes und der Verteilung der Hauptbaumarten.'

                                // description={"aiueo"}
                                >
                                    <EmailIcon size={iconSize} round />
                                </EmailShareButton>
                            </Grid>

                            <Grid item>

                                <WhatsappShareButton
                                    url={"https://map3d.remote-sensing-solutions.de/waldmonitor-deutschland/"}
                                    title="Release des Waldmonitors Deutschland"

                                // description={"aiueo"}
                                >
                                    <WhatsappIcon size={iconSize} round />
                                </WhatsappShareButton>
                            </Grid>

                        </Grid>
                    </Box>
                );
            title = t.layerCategories.teilen.name;

            break;


    }


    return (<>

        {mobile ?
            <LeftSubDrawerMobile
                title={title}
                {...props}

            >
                {content}
            </LeftSubDrawerMobile>

            :
            <LeftSubDrawerDesktop
                title={title}
                {...props}
            >
                {content}
            </LeftSubDrawerDesktop>
        }
    </>
    );
}


function SelectBundesland(props: any) {
    const t = useTranslation()

    const handleChange = (event: SelectChangeEvent) => {
        props.setBundesland(event.target.value as string);
    };

    return (
        <Box sx={{ m: 3 }}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{t.namesUIElements.bundeslandSelect.name}</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.bundesland}
                    label={t.namesUIElements.bundeslandSelect.name}
                    onChange={handleChange}
                >
                    {t.bundeslaenderList.map((item) =>
                        <MenuItem key={item.label} aria-label={item.label} value={item.label}>{item.name}</MenuItem>
                    )
                    }
                </Select>
            </FormControl>
        </Box>
    );
}

// interface ConfigItem {
//     label: string;
//     name: string;
// }